<template>
  <div class="downLoad">
    <div class="banner">
      <img src="@/assets/serve/downLoad/banner.png" alt="" />
    </div>
    <div class="xs-data">
      <div class="data-menu">
        <div
          v-for="(item, idx) in classList"
          :key="idx"
          @click="menuClick(item, idx)"
          class="menu-item"
          :class="{ active: idx === menuIndex }"
        >
          {{ item.class_name }}
        </div>
      </div>
      <div class="data-content">
        <h1 class="data-title">{{activeName || ''}}</h1>
        <div class="data-list">
          <div
            v-for="(item, idx) in resource"
            :key="idx"
            class="data-item"
          >
            <div class="data-bg">
              <p>{{ item.resource_name }}</p>
              <div class="pic">
                <div v-if="item.resource_type === 1 || item.resource_type === 2 || item.resource_type === 3" @click="view(item)" class="pic-icon">
                  <img src="@/assets/serve/downLoad/look.png" alt="">
                  <p>在线查看</p>
                </div>
                <div @click="itemInfo(item)" class="pic-icon">
                  <img src="@/assets/serve/downLoad/down.png" alt="">
                  <p>点击下载</p>
                </div>
              </div>
            </div>
            <p class="data-name">{{ item.resource_name }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="pop" :class="{'on': popOn}" @click="closePop">
      <div class="mask"></div>
      <div class="box">
        <div class="close" @click="closePop">
          <i class="el-icon-circle-close"></i>
        </div>
        <!-- 图片预览 -->
        <img class="pop-img" v-if="fileType === 1" :src="pdfUrl" alt="">

        <!-- pdf 预览 -->
        <template>
          <iframe v-if="fileType === 2 && download_user_type.indexOf(userInfo.user_type) <= -1" class="vf" :src="`${pdfUrl}?#toolbar=0`" frameborder="0"></iframe>
          <iframe v-else :src="`${pdfUrl}`" frameborder="0" class="vf"></iframe>
        </template>
        
        <!-- 视频预览 -->
        <video class="pop-video" v-if="fileType === 3" :src="pdfUrl" controls="controls">视频</video>
      </div>
    </div>
  </div>
</template>

<script>

import {
  resourceClassList,
  resourceList,
  resourceInfo
} from '@/api/download.js'
import Des from '@/util/des.js'

export default {
  name: 'DownLoad',
  props: {
    userInfo: {}
  },
  data() {
    return {
      look:false,
      fileType: '',
      popOn: false,
      pdfUrl: '',
      defaultId: null,
      menuIndex: null,
      download_user_type: '',
      view_user_type: '',
      dataUrl: {},
      classList: [],
      resource: [],
      activeName: ''
    }
  },
  created() {
    this.init()
    localStorage.getItem('giftsUser') ? '' : this.$emit('needLogin', true)
    // this.user = JSON.parse(localStorage.getItem('giftsUser')) || {}
  },
  methods: {
    async init() {
      await this.resourceClassList()
      // await this.resourceList()
    },
    resourceClassList() {
      const deskey = atob(localStorage.getItem('odeskey'))
      return resourceClassList({
        father_id: '-1'
      }).then(res => {
        if (res.result === 1) {
          this.classList = JSON.parse(Des.decryptByDES(res.dataList, deskey))
          this.defaultId = this.classList[0].id
          return res
        }
      })
    },
    resourceList(item, idx = 0) {
      const deskey = atob(localStorage.getItem('odeskey'))
      return resourceList({
        user_id: this.userInfo.id || '-1',
        class_id: this.defaultId,
        pageSize: 100,
        pageNum: 1
      }).then(res => {
        if (res.result === 1) {
          this.look = true
          this.menuIndex = idx
          this.resource = JSON.parse(Des.decryptByDES(res.dataList, deskey))
          this.activeName = item.class_name
          return res
        } else if (res.result === 2005) {
          this.look = true
          this.$alert(res.msg, '温馨提示', {
            confirmButtonText: '确定',
            showClose: false
          });
          return
        } else if(res.result === 2003) {
          this.$emit('needLogin', true)
          return
        } else {
          this.$alert(res.msg, '温馨提示', {
            confirmButtonText: '确定',
            showClose: false
          });
          return
        }
      })
    },
    menuClick(item, idx) {
      this.defaultId = item.id
      this.resourceList(item, idx)
      this.download_user_type = item.download_user_type
      this.view_user_type = item.view_user_type
    },
    itemInfo(item) {
      if (this.download_user_type.indexOf(this.userInfo.user_type) <= -1 ) {
        return this.$alert('您没有下载该类型资源的权限', '温馨提示', {
          confirmButtonText: '确定',
        });
      }
      const deskey = atob(localStorage.getItem('odeskey'))
      resourceInfo({
        user_id: this.userInfo.id || '-1',
        id: item.id
      }).then(res => {
        this.dataUrl = JSON.parse(Des.decryptByDES(res.data, deskey))
        this.dataUrl.resource_pic = this.dataUrl.resource_pic ? JSON.parse(this.dataUrl.resource_pic): ''
        this.dataUrl.resource_link = JSON.parse(this.dataUrl.resource_link)

        const fileContent = this.dataUrl.resource_link[0].url
        const a = document.createElement('a')
        a.href = fileContent
        a.download= fileContent
        document.body.appendChild(a)
        a.click()
        a.remove()
      })
    },
    view(item) {
      this.fileType = item.resource_type
      this.popOn = true
      this.pdfUrl = JSON.parse(item.resource_link)[0].url
    },
    closePop() {
      this.popOn = false
      this.pdfUrl = ''
    }
  }
}
</script>
<style lang="less" scoped>
p {
  margin: 0;
}
.downLoad {
  .banner {
    margin-bottom: 23px;
    img {
      width: 100%;
      vertical-align: top;
      border: none;
    }
  }
  .xs-data {
    width: 1440px;
    max-width: 1440px;
    margin: 0 auto 40px;
    display: flex;
    .data-menu {
      margin-right: 40px;
      width: 300px;
      height: 100%;
      padding: 40px 20px;
      background: #fff;
      box-sizing: border-box;
      box-shadow: 0px 0px 18px 0px rgba(216, 216, 216, 0.75);
      border-radius: 15px;
      .menu-item {
        cursor: pointer;
        height: 50px;
        line-height: 50px;
        font-size: 20px;
        font-weight: 400;
        color: #595858;
        margin-bottom: 15px;
        &.active {
          background: #4e8b46;
          border-radius: 50px;
          color: #fff;
        }
        &:last-child {
          margin: 0;
        }
      }
    }
    .data-content {
      text-align: left;
      width: 1100px;
      max-width: 1100px;
      background: #f5f8f4;
      box-shadow: 0px 0px 18px 0px rgba(216, 216, 216, 0.75);
      border-radius: 15px;
      padding: 39.5px 59.5px;
      box-sizing: border-box;
      .data-title {
        font-size: 24px;
        font-weight: 400;
        color: #4e8b46;
        line-height: 53px;
        border-bottom: 1px solid #cccccc;
        margin-bottom: 59.5px;
      }
      .data-list {
        display: flex;
        flex-wrap: wrap;
        .data-name {
          font-size: 20px;
          font-weight: 400;
          color: #595858;
          line-height: 27px;
        }
      }
      .data-item {
        width: 280px;
        margin-right: 40px;
        cursor: pointer;
        margin-bottom: 55px;
        text-align: center;
        
        .data-bg {
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 15px;
          width: 280px;
          height: 360px;
          position: relative;
          background: url('../../../assets/serve/downLoad/data.png') no-repeat;
          background-size: 280px 360px;
          margin-bottom: 28.5px;
          box-shadow: 0 0 0.09375rem 0 rgba(216, 216, 216, 0.75);
          p {
            font-size: 20px;
            font-weight: 400;
            color: #ffffff;
            line-height: 36px;
            text-shadow: 0px 0px 10px #4e8b46;
          }
          .pic{
            opacity: 0;
            position: absolute;
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            transition: opacity .3s ease-in-out;

            &::after{
              content: "";
              border-radius: 15px;
              position: absolute;
              width: 100%;
              height: 100%;
              top: 0;
              left: 0;
              background-color: rgba(0,0,0,.4);
              z-index: 4;
            }
            &:hover {
              opacity: 1;
            }
          }
        }
        
      }
      
    }
    .pic-icon{
      display: flex;
      z-index: 5;
      flex-direction: column;
      padding-bottom: 45px;
      align-items: center;
      &:last-child{
        padding: 0;
      }
      img {
        width: 76px;
        height: 76px;
        margin-bottom: 14px;
      }
    }
  }
  .pop{
    position: fixed;
    width: 100%;
    height: 100vh;
    left: 0;
    top: 0;
    z-index: 1000;
    display: none;
    align-items: center;
    justify-content: center;
    &.on{
      display: flex;
    }
    .mask{
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      background-color: rgba(0,0,0,.5);
      animation-fill-mode: both;
      animation-name: fadeIn;
      animation-duration: .5s;
      animation-timing-function: ease-in-out;
    }
    .close{
      font-size: 0;
      margin-bottom: 30px;
      i {
        cursor: pointer;
        font-size: 50px !important;
        color: #ffffff;
        z-index: 90;
        position: relative;
      }
    }
    .vf{
      display: block;
      width: 88vw;
      height: 80vh;
      z-index: 90;
      position: relative;
    }
    .pop-img {
      position: relative;
      z-index: 5;
    }
    .pop-video {
      width: 500px;
      position: relative;
      z-index: 5;
    }
  }
}
</style>
